import GeneralModal from '../../../components/GeneralModal/GeneralModal'
import { useState } from 'react'
import ImageInput from '../../../components/ImageInput/ImageInput'
import Dropdown from '../../../components/Dropdown/Dropdown'

const defaultValues = {
  image: null,
  repeat: 'no-repeat',
  position: 'top left',
  attachment: 'scroll',
  size: 'auto',
}

const PortfolioBackgroundImageModal = ({
  isOpen,
  onRequestClose,
  onSubmit,
  initialValues,
}) => {
  const [values, setValues] = useState({
    ...defaultValues,
    ...(initialValues || {}),
  })

  function handleSubmit() {
    onSubmit(values)
  }

  function handleRemove() {
    onSubmit(null)
  }

  function handleChange(name, value) {
    setValues({ ...values, [name]: value })
  }

  return (
    <GeneralModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Background Image"
      buttons={[
        {
          text: 'Save',
          className: 'button bg-pink hover:bg-pink-off',
          onClick: handleSubmit,
        },
      ]}
      secondaryButtons={[
        {
          text: 'Remove Image',
          className: 'button hover:bg-deep',
          onClick: handleRemove,
        },
      ]}
    >
      <div>
        <div>
          <ImageInput
            value={values.image}
            onChange={(image) => handleChange('image', image)}
          />
        </div>
        <div className="mt-4">
          <Dropdown
            label="Position"
            options={[
              { id: 'top left', name: 'Top Left' },
              { id: 'top center', name: 'Top Center' },
              { id: 'top right', name: 'Top Right' },
              { id: 'left', name: 'Left' },
              { id: 'center', name: 'Center' },
              { id: 'right', name: 'Right' },
              { id: 'bottom left', name: 'Bottom Left' },
              { id: 'bottom center', name: 'Bottom Center' },
              { id: 'bottom right', name: 'Bottom Right' },
            ]}
            value={values.position}
            onChange={(val) => handleChange('position', val)}
          ></Dropdown>
        </div>
        <div className="mt-2">
          <Dropdown
            label="Tile"
            options={[
              { id: 'no-repeat', name: 'None' },
              { id: 'repeat no-repeat', name: 'Tile Horizontally' },
              { id: 'no-repeat repeat', name: 'Tile Vertically' },
              { id: 'repeat repeat', name: 'Tile Both' },
            ]}
            value={values.repeat}
            onChange={(val) => handleChange('repeat', val)}
          ></Dropdown>
        </div>
        <div className="mt-2">
          <Dropdown
            label="Size"
            options={[
              { id: 'auto', name: 'Original' },
              { id: 'cover', name: 'Cover Area' },
              { id: 'contain', name: 'Contained within Area' },
            ]}
            value={values.size}
            onChange={(val) => handleChange('size', val)}
          ></Dropdown>
        </div>
      </div>
    </GeneralModal>
  )
}

export default PortfolioBackgroundImageModal
